// [[menuTitle, path, sectionId, pageTitle]]
export const MENU_HEADER = [
    ['Home', '/', 'home', ''],
    ['Services', '/#services', 'services'],
    ['Team', '/#team', 'team'],
    ['Projects', '/#projects', 'projects']
];
